import { render, staticRenderFns } from "./page-inspirations.vue?vue&type=template&id=bd7397aa"
import script from "./page-inspirations.js?vue&type=script&lang=js&external"
export * from "./page-inspirations.js?vue&type=script&lang=js&external"
import style0 from "./page-inspirations.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports